import { render, staticRenderFns } from "./SearchReports.vue?vue&type=template&id=3308fc18&"
import script from "./SearchReports.vue?vue&type=script&lang=js&"
export * from "./SearchReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports